<template>
  <div class="container">
    <header class="container-1">
      <div class="box">
        <div class="box-left new-class-top-header">
          <div class="wangye-ban"></div>
          <div class="zixun-ban" @click="goToZX"></div>
          <div class="right-login-userinfo">
            <div class="text1">欢迎来到农产品集购网!</div>
            <div class="text2 text2Login" v-if="isLogin" @click="toPersonalCenter">{{ userInfo.username }}</div>
            <div class="logout" v-if="isLogin" @click="logout">【退出】</div>
          </div>
        </div>
        <div class="liuyan-and-userinfo">
          <!-- <div v-if="true" style="display: inline-block;padding-right: 20px;border-right: 1px solid #d8d8d8;">
            <div class="box-right" @click="toPersonalCart" style="cursor: pointer;"
                 @mouseenter="cartHover = true"
                 @mouseleave="cartHover = false">
              <img class="icon" src="/static/img/header/no-cart.png" alt="" v-show="!cartHover">
              <img class="icon" src="/static/img/header/cart.png" alt="" v-show="cartHover">
              <div class="personalCenter">购物车</div>
            </div>
          </div> -->

          <div class="liu-yan" v-if="isLogin">
            <Poptip trigger="hover">
              <div style="display: flex;align-items: center;">
                <img src="../../assets/icon-shouji.png" alt=""
                     style="width: 12px;height: 16px;display: block">
                <div style="cursor: pointer;padding-top: 2px;padding-left: 3px">手机端</div>
              </div>
              <div class="api" slot="content">
                <div class="code-image-boxs">
                  <div class="code-content">
                    <img src="../../assets/26491708484314_pic.jpg" class="code-icon" />
                    <div class="code-title">客户端</div>
                  </div>
                  <div class="code-content">
                    <img src="../../assets/allite-icon.png" class="code-icon" />
                    <div class="code-title">小程序</div>
                  </div>
                </div>
              </div>
            </Poptip>
          </div>
          <template v-if="isLogin">
            <div class="shop-mai-zx" @click="toPersonalCenter">买家中心</div>
            <div class="shop-m-zx" v-if="showShopUser" @click="toPersonalCommodityManagement">卖家中心</div>
          </template>
          <!--            <div class="box-right" v-if="isLogin" @click="toPersonalCenter" style="cursor: pointer;">-->
          <!--              <div class="personalCenter">我的集购网</div>-->
          <!--            </div>-->
          <div class="box-right" v-else>
            <!--              <div class="login" @click="login">请登录</div>-->
            <!--              <div class="line"></div>-->
            <div class="login" @click="login">请登录</div>
            <div class="line"></div>
            <div class="register" @click="register">免费注册</div>
          </div>
          <div class="dianhua-time">400-16988-01</div>
          <div class="jiao-yi-time">交易时间：工作日 9:00-17:00</div>
        </div>
      </div>
    </header>
    <div v-if="is_up_under">
      <Modal v-model="is_up_under" width="480" class="modal_title2" :mask-closable="false" :styles="{top:'30%'}">
        <div>
          <div style="text-align: center;font-size: 18px;color: #333;margin-bottom: 24px;">用户留言</div>
          <Form ref="up_form" :model="up_form" :rules="up_form_rules" :label-width="90">
            <FormItem label="留言主题" prop="theme">
              <Input v-model="up_form.theme" placeholder="请输入内容，不超过10个字"></Input>
            </FormItem>
            <FormItem label="留言内容" prop="content">
              <Input v-model="up_form.content" type="textarea" :autosize="{minRows: 5,maxRows: 10}"
                     placeholder="请输入内容，不超过100个字"></Input>
            </FormItem>
          </Form>
        </div>
        <template #footer>
          <div style="display: flex;justify-content: center;padding-top: 12px;padding-bottom: 12px;">
            <Button size="large" class="cancel" style="width: 120px;height:40px;border: none" @click="delCancel">取消
            </Button>
            <Button size="large" class="confirm"
                    style="width: 120px;height:40px;background-color:#61A842;color: #fff;border: none"
                    @click="delConfirm('up_form')">确定
            </Button>
          </div>
        </template>
      </Modal>
    </div>
  </div>
</template>

<script>
import {getToken} from '@/utils/auth';
import {apiAddTheme} from '@/api/hm';
import {apiShopUser} from '@/api/product';


export default {
  name: 'M-Header',
  data () {
    return {
      showShopUser: false,
      isEnd16988com: !location.host.endsWith('16988.com'),
      isMessage: false,
      time: null,
      token: '',//用户token
      cartHover: false,
      is_up_under: false,
      up_form: {
        theme: '',
        content: ''
      },
      up_form_rules: {
        theme: [
          {required: true, message: '未输入', trigger: 'blur'},
          {max: 10, message: '不超过10个字！', trigger: 'blur'}
        ],
        content: [
          {required: true, message: '未输入', trigger: 'blur'},
          {max: 100, message: '不超过100个字！', trigger: 'blur'}
        ]
      }
    };
  },
  computed: {
    isLogin () {//是否已登陆
      return this.token ? true : false;
    },
    userInfo () {
      return this.$store.state.userInfo;
    }
  },
  watch: {
    '$store.state.token': {
      immediate: true,
      handler (v) {
        if (v != '') {
          this.token = v;
        }
      }
    },
    'token': {
      immediate: true,
      handler (v) {
        if (v) {
          if (!this.userInfo.username) {
            let userInfo = JSON.parse(localStorage.getItem('userInfo'));
            this.$store.state.userInfo = userInfo;
          }
        }
      }
    }
  },
  created () {
    this.token = getToken();
    if(this.token) {
      apiShopUser().then(res => {
        this.showShopUser = res.data
      });
    }
  },
  methods: {
    goToZX () {
      window.open('https://zixun.16988.com/', '_self');
    },
    leaveMessage () {
      this.is_up_under = true;
      this.isMessage = true;
    },
    delCancel () {
      this.is_up_under = false;
    },
    delConfirm (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          if (this.isMessage) {
            this.isMessage = false;
            apiAddTheme({title: this.up_form.theme, content: this.up_form.content}).then(
              res => {
                if (res.code === 200) {
                  this.$Message.success('留言成功');
                  this.is_up_under = false;
                  this.$refs[name].resetFields();
                }
              }
            );
          }
        } else {
          // this.$Message.error('Fail!');
        }
      });
    },
    login () {
      // 登陆
      this.$router.push('/UserLogin');
      // this.$router.push('/Login')
    },
    logout () {
      // 退出登陆
      this.$store.dispatch('signOut').then(res => {
        localStorage.setItem('shopUserInfoBack', null)
        this.$router.push({path: '/UserLogin'});
      }).catch(err => {
        console.log(err);
      });
    },
    register () {
      // 注册
      this.$router.push('/UserRegister');
    },
    toPersonalCenter () {
      // 前往个人中心页面
      if (!this.isLogin) return;
      this.$router.push('/PersonalCenter');
    },
    toPersonalCommodityManagement () {
      // 前往个人中心页面
      if (!this.isLogin) return;
      this.$router.push('/PersonalCommodityManagement');
    },
    toPersonalCart () {
      // 前往个人中心页面
      // if (!this.isLogin) return
      this.$router.push('/cart');
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../assets/styles/_common.scss";

.container {
  height: 34px;
  width: 100%;
}

.container-1 {
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #19262A;
  border-bottom: 1px solid #F0F0F0;

  .box {
    height: 100%;
    width: 1200px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .new-class-top-header {
      color: #FFFFFF;
      display: flex;
      align-items: center;

      .wangye-ban {
        display: inline-block;
        width: 80px;
        height: 28px;
        padding: 0;
        margin-right: 4px;
        margin-top: 6px;
        background: url('../../assets/targetjigou.png') no-repeat;
      }

      .zixun-ban {
        display: inline-block;
        width: 83px;
        height: 35px;
        padding: 0;
        margin-right: 16px;
        background: url('../../assets/targetqihuo.png') no-repeat;
      }

      .right-login-userinfo {
        display: flex;
        align-items: center;

        .text1 {
          font-size: 12px;
          font-family: Microsoft YaHei-Regular, Microsoft YaHei;
          font-weight: 400;
          color: #FFFFFF;
          cursor: default;
        }

        .text2 {
          font-size: 12px;
          font-family: Microsoft YaHei-Regular, Microsoft YaHei;
          font-weight: 400;
          color: #61A842;
          cursor: default;
          margin-left: 12px;
        }

        .text2Login {
          cursor: pointer;

          &:hover {
            color: $mainColor;
          }
        }

        .logout {
          margin-left: 8px;
          font-size: 12px;
          font-family: Microsoft YaHei-Regular, Microsoft YaHei;
          font-weight: 400;
          color: #999999;
          line-height: 16px;
          cursor: pointer;

          &:hover {
            color: $mainColor;
          }
        }
      }
    }
  }

  .liuyan-and-userinfo {
    display: flex;
    align-items: center;

    .liu-yan {
      color: #FFFFFF;
      .code-image-boxs{
        display: flex;
        align-items: center;
        .code-content{
          text-align: center;
          width: 82px;
          .code-icon{
            width: 82px;
            height: 82px;
          }
          .code-title{
            color: #262626;
            font-size: 14px;
          }
          &:last-child{
            margin-left: 20px;
          }
        }
      }
    }

    .userinfo-boxs {
      color: #FFFFFF;
      padding-left: 13px;
    }
    .shop-mai-zx{
      border-left: 1px solid #FFFFFF;
      color: #FFFFFF;
      padding-left: 13px;
      margin-left: 13px;
      cursor: pointer;
    }
    .shop-m-zx{
      border-left: 1px solid #FFFFFF;
      padding-left: 13px;
      color: #FFFFFF;
      margin-left: 13px;
      cursor: pointer;
    }
    .dianhua-time{
      border-left: 1px solid #FFFFFF;
      border-right: 1px solid #FFFFFF;
      color: #FFFFFF;
      padding: 0 13px;
      margin-left: 13px;
    }
    .jiao-yi-time {
      color: #FFFFFF;
      padding-left: 13px;
    }
  }
}

.line {
  height: 21px;
  width: 1px;
  background-color: #D8D8D8;
}

.box-right {
  display: flex;
  align-items: center;
  color: #FFFFFF;

  .login, .register {
    cursor: pointer;

    &:hover {
      color: $mainColor;
    }
  }

  .line {
    margin: 0 13px;
  }

  .icon {
    width: 12px;
    height: 12px;
  }

  .personalCenter {
    margin-left: 4px;
  }

  &:hover {
    .personalCenter {
      color: $mainColor;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/header/Header.vue